
import { Options, Vue } from 'vue-class-component'
import { Prop, PropSync } from 'vue-property-decorator'

@Options({
  emits: ['update:isShow', 'update:selectedCamera'],
  name: 'SelectionCameraPopup',
})
export default class SelectionCameraPopup extends Vue {
  @PropSync('isShow', { type: Boolean }) _isShow!: boolean
  @PropSync('selectedCamera', { type: String }) _selectedCamera!: string
  @Prop({ type: Array }) cameras!: MediaDeviceInfo[]

  closeDialog() {
    this._isShow = false
  }
}
